// StepHeader.tsx
import React from "react";
import { Box, Typography } from "@mui/material";
import { Help } from "../../../dialogs/HelpDialog";

type StepHeaderProps = {
    title: React.ReactNode;
    helpGuid?: string;
    dense?: boolean;
    divider?: boolean;

};

export const ValidationProcessStepHeader: React.FC<StepHeaderProps> = ({
    title,
    helpGuid,
    dense = false,
    divider = true,
}) => {

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                bgcolor: "grey.100",
                px: 1.5,
                py: dense ? 0.75 : 1,
                mb: dense ? 1 : 2,
                borderBottom: "1px solid",
                borderColor: "divider",
                boxShadow: "none",
            }}
        >
            <Typography
                variant={dense ? "subtitle2" : "subtitle1"}
                fontWeight={700}
                sx={{ textTransform: "uppercase", letterSpacing: ".06em" }}
            >
                {title}
            </Typography>
            {helpGuid && (
                <Help id={helpGuid} />
            )}
        </Box>
    );
};
